var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"wp-progress-bar"},[_c('div',{staticClass:"wp-progress-bar__title"},[_vm._t("default")],2),_c('div',{staticClass:"wp-progress-bar__bar"},[_c('div',{staticClass:"wp-progress-bar__bg"},[_c('div',{staticClass:"wp-progress-bar__line",style:({ opacity: _vm.value ? '1' : '0' })})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }